export class StorageService<Key extends string> implements Storage {
  private readonly api: Storage;

  public get length(): number {
    return this.api.length;
  }

  public constructor(api: Storage) {
    this.api = api;
  }

  public setItem(key: Key, value: any): void {
    this.api.setItem(key, JSON.stringify({ value }));
  }

  public getItem<T = unknown>(key: Key): T | null;
  public getItem<T = unknown>(key: Key, otherwise: T): T;
  public getItem<T = unknown>(key: Key, otherwise?: T): T | null {
    const data = this.api.getItem(key);
    if (data) {
      const { value } = JSON.parse(data);
      return value;
    }

    if (otherwise !== undefined) {
      return otherwise;
    }

    return null;
  }

  public hasItem(key: Key): boolean {
    return !!this.api.getItem(key);
  }

  public removeItem(key: Key): void {
    this.api.removeItem(key);
  }

  public clear(): void {
    this.api.clear();
  }

  public key(index: number): string | null {
    return this.api.key(index);
  }
}
